import API from '../utils/api'

const newsApiBaseUrl = '/api/news';
const contentUrl = newsApiBaseUrl + '/find/';


export function findNews(params) {
  return API.get(contentUrl, {
    params: params
  }).then(response => {
    return response
  })
}